module.exports = __webpack_public_path__ + "img/waves.b26f8bc1.png";